<template>
  <div id="container" class="mx-auto w-100">
    <mb>
      <section id="sec-0" class="d-flex align-items-center py-2">
        <x-menu :show="menuShow" :close-menu="() => {this.menuShow = false}"></x-menu>
        <div class="bread w-15 mx-2 p-3" @click="menuShow = true">
          <img :src="img.bread" alt="" class="w-100">
        </div>
        <div class="logo w-15">
          <img :src="img.logo" alt="" class="w-100">
        </div>
      </section>
    </mb>
    <section id="sec-1" class="position-relative">
      <responsive-img :pc="img.kv.pc" :mb="img.kv.mb" id="kv"></responsive-img>
      <x-menu></x-menu>
      <div class="links position-absolute d-flex justify-content-center">
        <a href="https://www.mombaby.com.tw/articles/9924472" class="mx-4 mx-md-5" target="_blank"><img :src="img.sec1.bt1" alt="" class="w-100"></a>
        <a href="#sec-2" class="mx-4 mx-md-5"><img :src="img.sec1.bt2" alt="" class="w-100"></a>
      </div>
    </section>
    <section class="position-relative">
      <responsive-anchor :pc="0" :mb="-3" :id="'sec-2'"></responsive-anchor>
      <responsive-img :pc="img.sec3.bg.pc" :mb="img.sec3.bg.mb"></responsive-img>
      <responsive-anchor :pc="20.5" :mb="12" :id="'sec-3'"></responsive-anchor>
      <mb>
        <div id="sec-3-slider" class="position-absolute absolute-center">
          <div class="prev-arrow position-absolute w-10">
            <img :src="img.sec3.prevArrow" alt="" class="w-100">
          </div>
          <div class="next-arrow position-absolute w-10">
            <img :src="img.sec3.nextArrow" alt="" class="w-100">
          </div>
          <swiper :modules="sec3Slider.modules" :navigation="sec3Slider.navigation">
            <swiper-slide class="slide">
              <input type="checkbox" class="visually-hidden" id="slide-31" v-model="slideStates.slide31">
              <div class="img">
                <img :src="img.sec3.slide.q1" alt="" class="w-100 q">
                <img :src="img.sec3.slide.a1" alt="" class="w-100 a">
              </div>
              <toggle-button class="position-absolute w-10"
                             :is-opening="slideStates.slide31"
                             :toggle="toggle(slideStates, 'slide31')"></toggle-button>
            </swiper-slide>
            <swiper-slide class="slide">
              <input type="checkbox" class="visually-hidden" id="slide-32" v-model="slideStates.slide32">
              <div class="img">
                <img :src="img.sec3.slide.q2" alt="" class="w-100 q">
                <img :src="img.sec3.slide.a2" alt="" class="w-100 a">
              </div>
              <toggle-button class="position-absolute w-10"
                             :is-opening="slideStates.slide32"
                             :toggle="toggle(slideStates, 'slide32')"></toggle-button>
            </swiper-slide>
            <swiper-slide class="slide">
              <input type="checkbox" class="visually-hidden" id="slide-33" v-model="slideStates.slide33">
              <div class="img">
                <img :src="img.sec3.slide.q3" alt="" class="w-100 q">
                <img :src="img.sec3.slide.a3" alt="" class="w-100 a">
              </div>
              <toggle-button class="position-absolute w-10"
                             :is-opening="slideStates.slide33"
                             :toggle="toggle(slideStates, 'slide33')"></toggle-button>
            </swiper-slide>
          </swiper>
        </div>
      </mb>
      <pc>
        <toggle-display :is-opening="imgStates.pc31">
          <div class="img w-30 position-absolute" :style="{left: '9%', top: '27.2%'}" >
            <img :src="img.sec3.pic31" alt="" class="w-100">
          </div>
        </toggle-display>
        <toggle-display :is-opening="imgStates.pc32">
          <div class="img w-30 position-absolute" :style="{right: '12%', top: '23%'}" >
            <img :src="img.sec3.pic32" alt="" class="w-100">
          </div>
        </toggle-display>
        <toggle-display :is-opening="imgStates.pc33">
          <div class="img w-30 position-absolute" :style="{right: '6%', top: '28%'}" >
            <img :src="img.sec3.pic33" alt="" class="w-100">
          </div>
        </toggle-display>
        <toggle-button position="absolute" :left="29.4" :top="30.4" :left2="30.7" :top2="27" :toggle="toggle(imgStates, 'pc31')" :is-opening="imgStates.pc31"></toggle-button>
        <toggle-button position="absolute" :right="24" :top="26.6" :right2="17" :top2="22.8" :toggle="toggle(imgStates, 'pc32')" :is-opening="imgStates.pc32"></toggle-button>
        <toggle-button position="absolute" :right="24" :top="31.4" :right2="8" :top2="27.7" :toggle="toggle(imgStates, 'pc33')" :is-opening="imgStates.pc33"></toggle-button>
      </pc>
      <responsive-anchor :pc="33.8" :mb="29.8" :id="'sec-4'"></responsive-anchor>
      <mb>
        <toggle-button position="absolute" :left="17" :top="39.3" class="w-5" :toggle="toggleOffFirst(imgStates.mb4, 'mb41')" :is-opening="imgStates.mb4.mb41" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="88" :top="40.7" class="w-5" :toggle="toggleOffFirst(imgStates.mb4, 'mb42')" :is-opening="imgStates.mb4.mb42" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="38" :top="49" class="w-5" :toggle="toggleOffFirst(imgStates.mb4, 'mb43')" :is-opening="imgStates.mb4.mb43" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="71" :top="45" class="w-5" :toggle="toggleOffFirst(imgStates.mb4, 'mb44')" :is-opening="imgStates.mb4.mb44" :hide-if-opening="true"></toggle-button>

        <toggle-display :is-opening="imgStates.mb4.mb41">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '44.5%'}">
            <img :src="img.sec4.mb41" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '49.4%'}" :link="links.shop.shop41" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="imgStates.mb4.mb42">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '44.5%'}">
            <img :src="img.sec4.mb42" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '49.4%'}" :link="links.shop.shop42" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="imgStates.mb4.mb43">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '44.5%'}">
            <img :src="img.sec4.mb43" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '49.4%'}" :link="links.shop.shop43" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="imgStates.mb4.mb44">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '44.5%'}">
            <img :src="img.sec4.mb44" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '49.4%'}" :link="links.shop.shop44" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="anyStateIsTrue(imgStates.mb4)">
          <toggle-button position="absolute" :left="78" :top="45" class="w-5" :toggle="toggleAllOff(imgStates.mb4)" :is-opening="anyStateIsTrue(imgStates.mb4)"></toggle-button>
        </toggle-display>
      </mb>
      <pc>
        <shop-now :style="{left: '32%', top: '40.6%'}" :link="links.shop.shop41" :width="8"></shop-now>
        <shop-now :style="{left: '78.6%', top: '39.5%'}" :link="links.shop.shop42" :width="8"></shop-now>
        <shop-now :style="{left: '35.7%', top: '52.2%'}" :link="links.shop.shop43" :width="8"></shop-now>
        <shop-now :style="{left: '86.6%', top: '52.1%'}" :link="links.shop.shop44" :width="8"></shop-now>
      </pc>
      <responsive-anchor :pc="53.6" :mb="47.4" :id="'sec-5'"></responsive-anchor>
      <mb>
        <toggle-button position="absolute" :left="60" :top="58" class="w-5" :toggle="toggleOffFirst(imgStates.mb5, 'mb51')" :is-opening="imgStates.mb5.mb51" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="74" :top="64" class="w-5" :toggle="toggleOffFirst(imgStates.mb5, 'mb52')" :is-opening="imgStates.mb5.mb52" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="40" :top="66.4" class="w-5" :toggle="toggleOffFirst(imgStates.mb5, 'mb53')" :is-opening="imgStates.mb5.mb53" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="23" :top="63.3" class="w-5" :toggle="toggleOffFirst(imgStates.mb5, 'mb54')" :is-opening="imgStates.mb5.mb54" :hide-if-opening="true"></toggle-button>
        <toggle-display :is-opening="imgStates.mb5.mb51">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '58%'}">
            <img :src="img.sec5.mb51" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '62.6%'}" :link="links.shop.shop51" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="imgStates.mb5.mb52">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '58%'}">
            <img :src="img.sec5.mb52" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '62.6%'}" :link="links.shop.shop52" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="imgStates.mb5.mb53">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '58%'}">
            <img :src="img.sec5.mb53" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '62.6%'}" :link="links.shop.shop53" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="imgStates.mb5.mb54">
          <div class="mb-img w-75 position-absolute absolute-center" :style="{top: '58%'}">
            <img :src="img.sec5.mb54" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '63%', top: '62.6%'}" :link="links.shop.shop54" :width="23"></shop-now>
        </toggle-display>
        <toggle-display :is-opening="anyStateIsTrue(imgStates.mb5)">
          <toggle-button position="absolute" :left="74" :top="58" class="w-5" :toggle="toggleAllOff(imgStates.mb5)" :is-opening="anyStateIsTrue(imgStates.mb5)"></toggle-button>
        </toggle-display>
      </mb>
      <pc>
        <shop-now :style="{left: '69.2%', top: '59.2%'}" :link="links.shop.shop51" :width="8"></shop-now>
        <shop-now :style="{left: '76%', top: '73.3%'}" :link="links.shop.shop52" :width="8"></shop-now>
        <shop-now :style="{left: '57%', top: '74.8%'}" :link="links.shop.shop53" :width="8"></shop-now>
        <shop-now :style="{left: '26.5%', top: '60%'}" :link="links.shop.shop54" :width="8"></shop-now>
      </pc>
      <responsive-anchor :pc="76" :mb="66" :id="'sec-6'"></responsive-anchor>
      <mb>
        <toggle-button position="absolute" :left="80" :top="82.8" class="w-5" :toggle="toggle(imgStates.sec6, 'sec61')" :is-opening="imgStates.sec6.sec61" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="80" :top="96.2" class="w-5" :toggle="toggle(imgStates.sec6, 'sec62')" :is-opening="imgStates.sec6.sec62" :hide-if-opening="true"></toggle-button>
        <toggle-display :is-opening="imgStates.sec6.sec61">
          <div class="img w-60 position-absolute absolute-center" :style="{top: '72.8%'}">
            <img :src="img.sec6.sec61.mb" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '55%', top: '81.8%'}" :link="links.shop.shop61" :width="23"></shop-now>
          <toggle-button position="absolute" :left="70" :top="72.3" class="w-5" :toggle="toggle(imgStates.sec6, 'sec61')" :is-opening="imgStates.sec6.sec61"></toggle-button>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec6.sec62">
          <div class="img w-60 position-absolute absolute-center" :style="{top: '85.6%'}">
            <img :src="img.sec6.sec62.mb" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '55%', top: '95.2%'}" :link="links.shop.shop62" :width="23"></shop-now>
          <toggle-button position="absolute" :left="70" :top="85.1" class="w-5" :toggle="toggle(imgStates.sec6, 'sec62')" :is-opening="imgStates.sec6.sec62"></toggle-button>
        </toggle-display>
      </mb>
      <pc>
        <toggle-button position="absolute" :left="70" :top="87.2" class="w-2" :toggle="toggle(imgStates.sec6, 'sec61')" :is-opening="imgStates.sec6.sec61" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="70" :top="97" class="w-2" :toggle="toggle(imgStates.sec6, 'sec62')" :is-opening="imgStates.sec6.sec62" :hide-if-opening="true"></toggle-button>
        <toggle-display :is-opening="imgStates.sec6.sec61">
          <div class="img w-20 position-absolute" :style="{top: '80.8%', right: '6%'}">
            <img :src="img.sec6.sec61.pc" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '84%', top: '86.3%'}" :link="links.shop.shop61" :width="9"></shop-now>
          <toggle-button position="absolute" :left="91" :top="80.5" class="w-2" :toggle="toggle(imgStates.sec6, 'sec61')" :is-opening="imgStates.sec6.sec61"></toggle-button>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec6.sec62">
          <div class="img w-20 position-absolute" :style="{top: '90.6%', right: '6%'}">
            <img :src="img.sec6.sec62.pc" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '84%', top: '96.5%'}" :link="links.shop.shop62" :width="9"></shop-now>
          <toggle-button position="absolute" :left="91" :top="90.3" class="w-2" :toggle="toggle(imgStates.sec6, 'sec62')" :is-opening="imgStates.sec6.sec62"></toggle-button>
        </toggle-display>
      </pc>
    </section>
    <section class="sec-7 position-relative">
      <responsive-anchor :pc="0" :mb="-10" :id="'sec-7'"></responsive-anchor>
      <responsive-img :pc="img.sec7.bg.pc" :mb="img.sec7.bg.mb"></responsive-img>
      <div class="wrap position-absolute absolute-center d-flex flex-wrap">
        <div class="qa qa1 w-50 cursor-pointer" @click="toggle(imgStates.sec7, 'qa1')()">
          <img :src="img.sec7.q1" alt="" class="w-100" v-if="!imgStates.sec7.qa1">
          <img :src="img.sec7.a1" alt="" class="w-100" v-else>
        </div>
        <div class="qa qa2 w-50 cursor-pointer" @click="toggle(imgStates.sec7, 'qa2')()">
          <img :src="img.sec7.q2" alt="" class="w-100" v-if="!imgStates.sec7.qa2">
          <img :src="img.sec7.a2" alt="" class="w-100" v-else>
        </div>
        <div class="qa qa3 w-50 cursor-pointer" @click="toggle(imgStates.sec7, 'qa3')()">
          <img :src="img.sec7.q3" alt="" class="w-100" v-if="!imgStates.sec7.qa3">
          <img :src="img.sec7.a3" alt="" class="w-100" v-else>
        </div>
        <div class="qa qa4 w-50 cursor-pointer" @click="toggle(imgStates.sec7, 'qa4')()">
          <img :src="img.sec7.q4" alt="" class="w-100" v-if="!imgStates.sec7.qa4">
          <img :src="img.sec7.a4" alt="" class="w-100" v-else>
        </div>
      </div>
    </section>
    <section class="position-relative">
      <responsive-anchor :pc="0" :mb="-3" :id="'sec-8'"></responsive-anchor>
      <responsive-img :pc="img.sec8.bg.pc" :mb="img.sec8.bg.mb"></responsive-img>
      <mb>
        <toggle-button position="absolute" :left="80" :top="15.7" class="w-5" :toggle="toggle(imgStates.sec8, 'sec81')" :is-opening="imgStates.sec8.sec81" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="80" :top="30.8" class="w-5" :toggle="toggle(imgStates.sec8, 'sec82')" :is-opening="imgStates.sec8.sec82" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="80" :top="45.9" class="w-5" :toggle="toggle(imgStates.sec8, 'sec83')" :is-opening="imgStates.sec8.sec83" :hide-if-opening="true"></toggle-button>
        <toggle-display :is-opening="imgStates.sec8.sec81">
          <div class="img w-60 position-absolute absolute-center" :style="{top: '3.8%'}">
            <img :src="img.sec8.sec81.mb" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '55%', top: '14.5%'}" :link="links.shop.shop81" :width="23"></shop-now>
          <toggle-button position="absolute" :left="70" :top="3.3" class="w-5" :toggle="toggle(imgStates.sec8, 'sec81')" :is-opening="imgStates.sec8.sec81"></toggle-button>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec8.sec82">
          <div class="img w-60 position-absolute absolute-center" :style="{top: '18.9%'}">
            <img :src="img.sec8.sec82.mb" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '55%', top: '29.6%'}" :link="links.shop.shop82" :width="23"></shop-now>
          <toggle-button position="absolute" :left="70" :top="18.4" class="w-5" :toggle="toggle(imgStates.sec8, 'sec82')" :is-opening="imgStates.sec8.sec82"></toggle-button>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec8.sec83">
          <div class="img w-60 position-absolute absolute-center" :style="{top: '35.2%'}">
            <img :src="img.sec8.sec83.mb" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '55%', top: '44.7%'}" :link="links.shop.shop83" :width="23"></shop-now>
          <toggle-button position="absolute" :left="70" :top="34.7" class="w-5" :toggle="toggle(imgStates.sec8, 'sec83')" :is-opening="imgStates.sec8.sec83"></toggle-button>
        </toggle-display>
      </mb>
      <pc>
        <toggle-button position="absolute" :left="70" :top="15.4" class="w-2" :toggle="toggle(imgStates.sec8, 'sec81')" :is-opening="imgStates.sec8.sec81" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="70" :top="28.7" class="w-2" :toggle="toggle(imgStates.sec8, 'sec82')" :is-opening="imgStates.sec8.sec82" :hide-if-opening="true"></toggle-button>
        <toggle-button position="absolute" :left="70" :top="42" class="w-2" :toggle="toggle(imgStates.sec8, 'sec83')" :is-opening="imgStates.sec8.sec83" :hide-if-opening="true"></toggle-button>
        <toggle-display :is-opening="imgStates.sec8.sec81">
          <div class="img w-20 position-absolute" :style="{top: '6.8%', right: '6%'}">
            <img :src="img.sec8.sec82.pc" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '84%', top: '14.5%'}" :link="links.shop.shop81" :width="9"></shop-now>
          <toggle-button position="absolute" :left="91" :top="6.4" class="w-2" :toggle="toggle(imgStates.sec8, 'sec81')" :is-opening="imgStates.sec8.sec81"></toggle-button>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec8.sec82">
          <div class="img w-20 position-absolute" :style="{top: '19.9%', right: '6%'}">
            <img :src="img.sec8.sec81.pc" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '84%', top: '27.6%'}" :link="links.shop.shop82" :width="9"></shop-now>
          <toggle-button position="absolute" :left="91" :top="19.5" class="w-2" :toggle="toggle(imgStates.sec8, 'sec82')" :is-opening="imgStates.sec8.sec82"></toggle-button>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec8.sec83">
          <div class="img w-20 position-absolute" :style="{top: '34.2%', right: '6%'}">
            <img :src="img.sec8.sec83.pc" alt="" class="w-100">
          </div>
          <shop-now :style="{left: '84%', top: '41%'}" :link="links.shop.shop83" :width="9"></shop-now>
          <toggle-button position="absolute" :left="91" :top="33.9" class="w-2" :toggle="toggle(imgStates.sec8, 'sec83')" :is-opening="imgStates.sec8.sec83"></toggle-button>
        </toggle-display>
      </pc>
      <responsive-anchor :pc="46" :mb="47.2" id="sec-9"></responsive-anchor>
      <pc>
        <div class="img w-10 position-absolute" :style="{top: '67.7%', left: '42%'}">
          <a href="https://www.mombaby.com.tw/articles/9924272" target="_blank">
            <img :src="img.sec9.sec91" alt="" class="w-100">
          </a>
        </div>
      </pc>
      <mb>
        <div class="img w-20 position-absolute" :style="{top: '68.6%', left: '42%'}">
          <a href="https://www.mombaby.com.tw/articles/9924272" target="_blank">
            <img :src="img.sec9.sec91" alt="" class="w-100">
          </a>
        </div>
      </mb>
      <responsive-anchor :pc="77.9" :mb="76.2" id="sec-10"></responsive-anchor>
      <mb>
        <div id="sec-10-slider" class="position-absolute absolute-center">
          <div class="prev-arrow position-absolute w-10">
            <img :src="img.sec3.prevArrow" alt="" class="w-100">
          </div>
          <div class="next-arrow position-absolute w-10">
            <img :src="img.sec3.nextArrow" alt="" class="w-100">
          </div>
          <swiper :modules="sec10Slider.modules" :navigation="sec10Slider.navigation">
            <swiper-slide class="slide">
              <input type="checkbox" class="visually-hidden" id="slide-101" v-model="slideStates.slider101">
              <div class="img">
                <img :src="img.sec10.slide.q1" alt="" class="w-100 q">
                <img :src="img.sec10.slide.a1" alt="" class="w-100 a">
              </div>
              <toggle-button class="position-absolute w-10"
                             :is-opening="slideStates.slider101"
                             :toggle="toggle(slideStates, 'slider101')"></toggle-button>
            </swiper-slide>
            <swiper-slide class="slide">
              <input type="checkbox" class="visually-hidden" id="slide-102" v-model="slideStates.slider102">
              <div class="img">
                <img :src="img.sec10.slide.q2" alt="" class="w-100 q">
                <img :src="img.sec10.slide.a2" alt="" class="w-100 a">
              </div>
              <toggle-button class="position-absolute w-10"
                             :is-opening="slideStates.slider102"
                             :toggle="toggle(slideStates, 'slider102')"></toggle-button>
            </swiper-slide>
            <swiper-slide class="slide">
              <input type="checkbox" class="visually-hidden" id="slide-103" v-model="slideStates.slider103">
              <div class="img">
                <img :src="img.sec10.slide.q3" alt="" class="w-100 q">
                <img :src="img.sec10.slide.a3" alt="" class="w-100 a">
              </div>
              <toggle-button class="position-absolute w-10"
                             :is-opening="slideStates.slider103"
                             :toggle="toggle(slideStates, 'slider103')"></toggle-button>
            </swiper-slide>
          </swiper>
        </div>
      </mb>
      <pc>
        <toggle-display :is-opening="imgStates.sec10.sec101">
          <div class="img w-25 position-absolute" :style="{left: '10%', bottom: '2%'}" >
            <img :src="img.sec10.pc101" alt="" class="w-100">
          </div>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec10.sec102">
          <div class="img w-25 position-absolute" :style="{right: '15%', bottom: '10%'}" >
            <img :src="img.sec10.pc102" alt="" class="w-100">
          </div>
        </toggle-display>
        <toggle-display :is-opening="imgStates.sec10.sec103">
          <div class="img w-25 position-absolute" :style="{right: '13%', bottom: '0.3%'}" >
            <img :src="img.sec10.pc103" alt="" class="w-100">
          </div>
        </toggle-display>
        <toggle-button position="absolute" :left="20.4" :bottom="6.4" :left2="30.4" :bottom2="12.1" :toggle="toggleOffFirst(imgStates.sec10, 'sec101')" :is-opening="imgStates.sec10.sec101"></toggle-button>
        <toggle-button position="absolute" :right="24" :bottom="11.5" :right2="18" :bottom2="19.9" :toggle="toggleOffFirst(imgStates.sec10, 'sec102')" :is-opening="imgStates.sec10.sec102"></toggle-button>
        <toggle-button position="absolute" :right="23" :bottom="3.6" :right2="16" :bottom2="11" :toggle="toggleOffFirst(imgStates.sec10, 'sec103')" :is-opening="imgStates.sec10.sec103"></toggle-button>
      </pc>
    </section>
    <footer>
      <div class="copyright text-center mx-auto">
        Copyright 2022.媽媽寶寶 All rights reserved.版權所有，禁止擅自轉貼節錄
      </div>
    </footer>
  </div>
</template>

<script>
import {reactive, computed} from "vue";
import ResponsiveImg from "@/components/ResponsiveImg";
import XMenu from "@/components/XMenu";
import ResponsiveAnchor from "@/components/ResponsiveAnchor";
import ToggleButton from "@/components/ToggleButton";
import Pc from '@/components/Pc'
import Mb from '@/components/Mb'
import ToggleDisplay from "@/components/ToggleDisplay";
import ShopNow from "@/components/ShopNow";

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper';

export default {
  name: 'App',
  components: {
    Swiper,
    SwiperSlide,
    ResponsiveAnchor,
    ResponsiveImg,
    XMenu,
    ToggleButton,
    Pc,
    Mb,
    ToggleDisplay,
    ShopNow
  },
  provide() {
    return {
      states: reactive({
        isMobile: computed(() => this.isMobile),
      })
    }
  },
  setup() {
    return {
      sec3Slider: {
        navigation: {
          enabled: true,
          prevEl: '#sec-3-slider .prev-arrow',
          nextEl: '#sec-3-slider .next-arrow'
        },
        modules: [Navigation]
      },
      sec10Slider: {
        navigation: {
          enabled: true,
          prevEl: '#sec-10-slider .prev-arrow',
          nextEl: '#sec-10-slider .next-arrow'
        },
        modules: [Navigation]
      }
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      menuShow: false,
      scrollTop: 0,
      img: {
        logo: require('./assets/img/logo.png'),
        bread: require('./assets/img/mb/bread.png'),
        plus: require('./assets/img/plus.png'),
        minus: require('./assets/img/minus.png'),
        kv: {
          pc: require('./assets/img/pc/PC1-2.png'),
          mb: require('./assets/img/mb/1-3.png'),
        },
        sec1: {
          bt1: require('./assets/img/PC1-3.png'),
          bt2: require('./assets/img/PC1-4.png'),
        },
        sec3: {
          bg: {
            pc: require('./assets/img/pc/pc2-1.png'),
            mb: require('./assets/img/mb/2-1.png'),
          },
          prevArrow: require('./assets/img/mb/3-6.png'),
          nextArrow: require('./assets/img/mb/3-7.png'),
          slide: {
            q1: require('./assets/img/mb/3-1Q.png'),
            a1: require('./assets/img/mb/3-1A.png'),
            q2: require('./assets/img/mb/3-2Q.png'),
            a2: require('./assets/img/mb/3-2A.png'),
            q3: require('./assets/img/mb/3-3Q.png'),
            a3: require('./assets/img/mb/3-3A.png'),
          },
          pic31: require('./assets/img/pc/pc3-1.png'),
          pic32: require('./assets/img/pc/pc3-2.png'),
          pic33: require('./assets/img/pc/pc3-3.png'),
        },
        sec4: {
          mb41: require('./assets/img/mb/4-1.png'),
          mb42: require('./assets/img/mb/4-2.png'),
          mb43: require('./assets/img/mb/4-3.png'),
          mb44: require('./assets/img/mb/4-4.png'),
        },
        sec5: {
          mb51: require('./assets/img/mb/5-1.png'),
          mb52: require('./assets/img/mb/5-2.png'),
          mb53: require('./assets/img/mb/5-3.png'),
          mb54: require('./assets/img/mb/5-4.png'),
        },
        sec6: {
          sec61: {
            pc: require('./assets/img/pc/pc6-1.png'),
            mb: require('./assets/img/mb/6-1.png'),
          },
          sec62: {
            pc: require('./assets/img/pc/pc6-2.png'),
            mb: require('./assets/img/mb/6-2.png'),
          },
        },
        sec7: {
          bg: {
            pc: require('./assets/img/pc/pc7-1.png'),
            mb: require('./assets/img/mb/7-1.png')
          },
          q1: require('./assets/img/pc7-2Q.png'),
          a1: require('./assets/img/pc7-2A.png'),
          q2: require('./assets/img/pc7-3Q.png'),
          a2: require('./assets/img/pc7-3A.png'),
          q3: require('./assets/img/pc7-4Q.png'),
          a3: require('./assets/img/pc7-4A.png'),
          q4: require('./assets/img/pc7-5Q.png'),
          a4: require('./assets/img/pc7-5A.png'),
        },
        sec8: {
          bg: {
            pc: require('./assets/img/pc/pc8-1.png'),
            mb: require('./assets/img/mb/8-1.png')
          },
          sec81: {
            pc: require('./assets/img/pc/pc8-3.png'),
            mb: require('./assets/img/mb/8-3.png')
          },
          sec82: {
            pc: require('./assets/img/pc/pc8-2.png'),
            mb: require('./assets/img/mb/8-2.png')
          },
          sec83: {
            pc: require('./assets/img/pc/pc8-4.png'),
            mb: require('./assets/img/mb/8-4.png')
          }
        },
        sec9: {
          sec91: require('./assets/img/pc9-1.png')
        },
        sec10: {
          slide: {
            q1: require('./assets/img/mb/10-1.png'),
            a1: require('./assets/img/mb/10-4.png'),
            q2: require('./assets/img/mb/10-2.png'),
            a2: require('./assets/img/mb/10-5.png'),
            q3: require('./assets/img/mb/10-3.png'),
            a3: require('./assets/img/mb/10-6.png'),
          },
          pc101: require('./assets/img/pc/pc10-1.png'),
          pc102: require('./assets/img/pc/pc10-2.png'),
          pc103: require('./assets/img/pc/pc10-3.png'),
        }
      },
      slideStates: {
        slide31: false,
        slide32: false,
        slide33: false,
        slider101: false,
        slider102: false,
        slider103: false,
      },
      imgStates: {
        pc31: false,
        pc32: false,
        pc33: false,
        mb4: {
          mb41: false,
          mb42: false,
          mb43: false,
          mb44: false,
        },
        mb5: {
          mb51: false,
          mb52: false,
          mb53: false,
          mb54: false,
        },
        sec6: {
          sec61: false,
          sec62: false,
        },
        sec7: {
          qa1: false,
          qa2: false,
          qa3: false,
          qa4: false,
        },
        sec8: {
          sec81: false,
          sec82: false,
        },
        sec10: {
          sec101: false,
          sec102: false,
          sec103: false,
        }
      },
      links: {
        shop: {
          shop41: 'https://www.norbelbaby.com.tw/nec/product/7174121/view',
          shop42: 'https://www.norbelbaby.com.tw/nec/product/7198413/view',
          shop43: 'https://www.norbelbaby.com.tw/nec/product/category/D9CYp4DjM4tg6wJC',
          shop44: 'https://www.norbelbaby.com.tw/nec/product/7197689/view',
          shop51: 'https://www.norbelbaby.com.tw/nec/product/2361520/view',
          shop52: 'https://www.norbelbaby.com.tw/nec/product/1410005/view',
          shop53: 'https://www.norbelbaby.com.tw/nec/product/2401468/view',
          shop54: 'https://www.norbelbaby.com.tw/nec/product/2401469/view',
          shop61: 'https://www.norbelbaby.com.tw/nec/product/category/032zW4aZsDrq0rG4',
          shop62: 'https://www.norbelbaby.com.tw/nec/product/6060111/view',
          shop81: 'https://www.norbelbaby.com.tw/nec/product/7190891/view',
          shop82: 'https://www.norbelbaby.com.tw/nec/product/7197092/view',
          shop83: 'https://www.norbelbaby.com.tw/nec/product/category/e79yP3Ejm0TMBhqf',
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onScroll);
    })
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    onScroll() {
      this.scrollTop = window.scrollY
    },
    toggle(object, key) {
      return () => {
        object[key] = !object[key]
      }
    },
    toggleAllOff(object) {
      return () => {
        Object.keys(object).forEach(key => {
          object[key] = false
        })
      }
    },
    toggleOffFirst(object, key) {
      return () => {
        let oState = object[key]
        this.toggleAllOff(object)()
        object[key] = oState
        object[key] = !object[key]
      }
    },
    anyStateIsTrue(object) {
      return Object.keys(object).some(key => {
        return object[key] === true
      })
    }
  }
}
</script>

<style lang="scss">

</style>
